import { isSafari } from "react-device-detect";

import DisableZoom from "./DisableZoom";

function DisableZoomSafari() {
  return isSafari ? <DisableZoom overrideMobile={true} /> : <></>;
}

export default DisableZoomSafari;
